import { Routes, Route } from "react-router-dom";

// Páginas administrativas
import ResourceTypes from "@/pages/admin/ResourceTypes";
import AdminUsersPage from "@/pages/admin/Users";
import Seniorities from "@/pages/admin/Seniorities";
import Positions from "@/pages/admin/Positions";
import AdminClientsPage from "@/pages/admin/ClientsPage";
import ProjectsPage from "@/pages/admin/ProjectsPage";
import UpdateWindowsPage from "@/pages/admin/UpdateWindowsPage";
import DepartmentsPage from "@/pages/Departments";
import MigrationTools from "@/pages/admin/MigrationTools";
import ExportsPage from "@/pages/admin/ExportsPage";
import CompanySettingsPage from "@/pages/admin/CompanySettingsPage";
import EvaluationThresholdsPage from "@/pages/admin/EvaluationThresholdsPage";

import { ROLE_COMBINATIONS } from "@/router/proxyRouter.definitions";
import { RoleBasedRoute } from "..";

import { PerformanceCriteriaPage } from "@/features/PerformanceCriteria/pages/PerformanceCriteriaPage";

export default function AdminRoutes() {
  return (
    <Routes>
      {/* ... other routes ... */}

      {/* Tipos de Recursos */}
      <Route
        path="resource-types"
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_ONLY}>
            <ResourceTypes />
          </RoleBasedRoute>
        }
      />

      {/* Usuários */}
      <Route
        path="users"
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_ONLY}>
            <AdminUsersPage />
          </RoleBasedRoute>
        }
      />

      {/* Senioridades */}
      <Route
        path="seniorities"
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_ONLY}>
            <Seniorities />
          </RoleBasedRoute>
        }
      />

      {/* Cargos */}
      <Route
        path="positions"
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_ONLY}>
            <Positions />
          </RoleBasedRoute>
        }
      />

      {/* Parâmetros de Avaliação */}
      <Route
        path="evaluation-thresholds"
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_ONLY}>
            <EvaluationThresholdsPage />
          </RoleBasedRoute>
        }
      />

      {/* Clientes */}
      <Route
        path="clients"
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_ONLY}>
            <AdminClientsPage />
          </RoleBasedRoute>
        }
      />

      {/* Projetos */}
      <Route
        path="projects"
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_ONLY}>
            <ProjectsPage />
          </RoleBasedRoute>
        }
      />

      {/* Departamentos */}
      <Route
        path="departments"
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_ONLY}>
            <DepartmentsPage />
          </RoleBasedRoute>
        }
      />

      {/* Janelas de Atualização */}
      <Route
        path="update-windows"
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_ONLY}>
            <UpdateWindowsPage />
          </RoleBasedRoute>
        }
      />

      {/* Ferramentas de Migração */}
      <Route
        path="migrations"
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_ONLY}>
            <MigrationTools />
          </RoleBasedRoute>
        }
      />

      {/* Exportações */}
      <Route
        path="exports"
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_ONLY}>
            <ExportsPage />
          </RoleBasedRoute>
        }
      />

      {/* Configurações da Empresa (Encargos) */}
      <Route
        path="company-settings"
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_ONLY}>
            <CompanySettingsPage />
          </RoleBasedRoute>
        }
      />

    </Routes>
  );
}
